var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediamodifierDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "5a92fa3a-ea6e-42a2-9507-be3aa759ffc6"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "3e0cd723-a98a-4910-afaf-343037e099bd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "489d2f43-b310-46f4-b81b-6f8fcfd5d11a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(190,174,255)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(190,174,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-254.5, -255.77)",
    d: "M 447.19 347.03 C 447.19 329.96999999999997 461.04 316.11999999999995 478.1 316.11999999999995 C 495.15000000000003 316.11999999999995 509 329.96999999999997 509 347.03 L 509 434.84999999999997 C 509 455.92999999999995 500.37 475.14 486.49 489.03 C 472.61 502.90999999999997 453.4 511.53999999999996 432.31 511.53999999999996 L 76.69 511.53999999999996 C 55.599999999999994 511.53999999999996 36.39 502.90999999999997 22.509999999999998 489.03 C 8.63 475.14 0 455.93 0 434.85 L 0 76.69 C 0 55.599999999999994 8.63 36.39 22.51 22.509999999999998 C 36.39 8.63 55.6 0 76.69 0 L 163.67000000000002 0 C 180.73000000000002 0 194.57000000000002 13.85 194.57000000000002 30.9 C 194.57000000000002 47.959999999999994 180.73000000000002 61.81 163.67000000000002 61.81 L 76.69 61.81 C 72.62 61.81 68.87 63.5 66.17999999999999 66.18 C 63.49999999999999 68.87 61.809999999999995 72.62 61.809999999999995 76.69000000000001 L 61.809999999999995 434.85 C 61.809999999999995 438.91 63.49999999999999 442.67 66.17999999999999 445.35 C 68.86999999999999 448.03000000000003 72.61999999999999 449.73 76.69 449.73 L 432.31 449.73 C 436.38 449.73 440.13 448.03000000000003 442.82 445.35 C 445.5 442.67 447.19 438.91 447.19 434.85 L 447.19 347.03000000000003 z M 447.19 103.46999999999997 L 308.15 244.28 C 296.23999999999995 256.4 276.7 256.56 264.59 244.65 C 252.47999999999996 232.74 252.30999999999997 213.20000000000002 264.21999999999997 201.09 L 401.77 61.81 L 309.7 61.81 C 292.64 61.81 278.8 47.96 278.8 30.900000000000002 C 278.8 13.850000000000001 292.64 3.552713678800501e-15 309.7 3.552713678800501e-15 L 478.1 3.552713678800501e-15 C 495.15 0 509 13.85 509 30.9 L 509 195.94 C 509 213 495.15 226.84 478.1 226.84 C 461.04 226.84 447.19 213 447.19 195.94 L 447.19 103.47 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediamodifierDesign);
export default __webpack_public_path__ + "static/media/Mediamodifier-Design.3754e18b59ebd87ce34ef1d2db5b577d.svg";
export { ForwardRef as ReactComponent };